import { Box, FormControl } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import { isNotEmpty, isObjectNotEmpty } from "../../Utils";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const styles = (theme) => ({
    container: {
        position: "relative",
        width: "100%",
    },
});

function CustomMultiSelect({
    label = "",
    control,
    classes = {},
    name,
    required = true,
    showError = true,
    value = [],
    selectOptions = [], //下拉可選的數組數據
    disableCloseOnSelect = true, //選擇后立即關閉下拉框
    fullWidth = false,
    toolTip = null,
    checkBoxIcon = false, //下拉框的list是否顯示checkbox
    onChange = () => {},
    getOptionLabel = (option) => option, //
    groupBy = () => {}, //可根據傳入條件分組，詳情見https://mui.com/zh/components/autocomplete/#grouped
    ...rest
}) {
    const { t, i18n } = useTranslation();

    const [fieldValue, setValue] = useState(value);

    useEffect(() => {
        setValue(value);
    }, [value]);

    const checkBoxLi = (props, option, { selected }) => {
        return (
            <li {...props}>
                <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={Boolean(
                        fieldValue.find((value) => value.title === option.title)
                    )}
                />
                {option.title}
            </li>
        );
    };
    return (
        <Controller
            className={classes.container}
            control={control}
            name={name}
            render={({ field, fieldState: { error } }) => (
                <FormControl
                    error={isObjectNotEmpty(error)}
                    className={classes.container}
                >
                    {isNotEmpty(label) && (
                        <Box mt={3} mb={3} display="flex" alignItems="center">
                            {label}
                            {i18n.language === "en" ? ":" : "："}
                            {required && (
                                <Box component="span" className="danger">
                                    *
                                </Box>
                            )}
                            {isNotEmpty(toolTip) ? toolTip : null}
                        </Box>
                    )}
                    <Autocomplete
                        multiple
                        value={fieldValue}
                        // onChange={(event, newValue) => {
                        //     field.onChange(newValue);
                        //     setValue(newValue);
                        // }}
                        onChange={(event, newValue) => {
                            let prArr = [...field.value];
                            if (
                                field.value?.length > 0 &&
                                newValue.length > 0
                            ) {
                                let _index = -1;
                                prArr.find((value, index) => {
                                    value.title === event.target.innerText
                                        ? (_index = index)
                                        : "";
                                });

                                if (_index > -1) {
                                    prArr.splice(_index, 1);
                                }
                            }

                            field.onChange(
                                prArr.length < field.value?.length
                                    ? [...prArr]
                                    : [...newValue]
                            );
                            setValue(
                                prArr.length < field.value?.length
                                    ? [...prArr]
                                    : [...newValue]
                            );
                        }}
                        options={selectOptions}
                        disableCloseOnSelect={disableCloseOnSelect}
                        getOptionLabel={getOptionLabel}
                        groupBy={groupBy}
                        renderOption={checkBoxIcon ? checkBoxLi : null}
                        style={fullWidth ? { width: "100%" } : { width: "80%" }}
                        renderInput={(params) => (
                            <TextField {...params} variant="standard" />
                        )}
                        renderGroup={(params) => (
                            <Box>
                                <Box
                                    style={{ margin: "5px", fontSize: "14px" }}
                                >
                                    {params.group}
                                </Box>
                                <ul>{params.children}</ul>
                            </Box>
                        )}
                        {...rest}
                    />
                    {showError && <ErrorMsg message={error?.message} />}
                </FormControl>
            )}
        />
    );
}
export default withStyles(styles)(CustomMultiSelect);
